import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// --- Italiano ---
import commonIT from './locales/it/common.json';
import shellIT from './locales/it/shell.json';
import picklistIT from './locales/it/picklist.json';
import warehouseIT from './locales/it/warehouse.json';
import userIT from './locales/it/user.json';
import tenantIT from './locales/it/tenant.json';
import catalogIT from './locales/it/catalog.json';
import auditIT from './locales/it/audit.json';
import liveIT from './locales/it/live.json';
import assignmentIT from './locales/it/assignment.json';
import voiceIT from './locales/it/voice.json';
import authIT from './locales/it/auth.json';

// --- English ---
import commonEN from './locales/en/common.json';
import shellEN from './locales/en/shell.json';
import picklistEN from './locales/en/picklist.json';
import warehouseEN from './locales/en/warehouse.json';
import userEN from './locales/en/user.json';
import tenantEN from './locales/en/tenant.json';
import catalogEN from './locales/en/catalog.json';
import auditEN from './locales/en/audit.json';
import liveEN from './locales/en/live.json';
import assignmentEN from './locales/en/assignment.json';
import voiceEN from './locales/en/voice.json';
import authEN from './locales/en/auth.json';

const resources = {
  it: {
    common: commonIT,
    shell: shellIT,
    picklist: picklistIT,
    warehouse: warehouseIT,
    user: userIT,
    tenant: tenantIT,
    catalog: catalogIT,
    audit: auditIT,
    live: liveIT,
    assignment: assignmentIT,
    voice: voiceIT,
    auth: authIT,
  },
  en: {
    common: commonEN,
    shell: shellEN,
    picklist: picklistEN,
    warehouse: warehouseEN,
    user: userEN,
    tenant: tenantEN,
    catalog: catalogEN,
    audit: auditEN,
    live: liveEN,
    assignment: assignmentEN,
    voice: voiceEN,
    auth: authEN,
  },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'it',
    defaultNS: 'common',
    ns: [
      'common', 'shell', 'picklist', 'warehouse', 'user',
      'tenant', 'catalog', 'audit', 'live', 'assignment',
      'voice', 'auth',
    ],
    interpolation: {
      escapeValue: false, // React già escapa
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'vp-language',
    },
  });

export default i18n;
